import gsap from "gsap";

export default function pageLoading() {
  /***********************************************************************
   * 変数定義
   ***********************************************************************/
  const wrapper = document.querySelector('.loading_wrapper');
  const mask = document.querySelector('.loading_mask');
  const linkEls = [
    ...document.querySelectorAll('a:not([href*="#"]):not([href*="tel:"]):not([target])'),
  ];
  const currentHostName = window.location.hostname;
  const isHomePage =
    document.body.classList.contains('home') ||
    document.body.classList.contains('index') ||
    document.body.classList.contains('front-page');
  const mvStartOffset = isHomePage ? '-=0.15' : '-=1.1';
  const mvTitleStartOffset = isHomePage ? '-=0.15' : '-=0.7';
  const mvSubTitleStartOffset = isHomePage ? '-=0.35' : '-=0.7';
  const mvImgPrimary = document.querySelector('.cmn_mv');
  const mvImgSecondary = document.querySelector('.index_mv02');
  const mvCirclePrimary = document.querySelector('.cmn_circle01');
  const mvCircleSecondary = document.querySelector('.cmn_circle02');
  const mvTitle = document.querySelector('.index_ttl, .lower_ttl_ja');
  const mvSubTitle = document.querySelector('.index_sub_ttl, .lower_ttl_en');
  const header = document.querySelector('.header');
  const menuTrigger = document.querySelector('.menu-trigger');

  const floatingTweens = [];
  const enterTime = 1.5; // ページ読み込み時のアニメーションの時間 単位：秒
  const leaveTime = 1; // ページ離脱時のアニメーション 単位：秒

  const tl = gsap.timeline();

  /*
  <<< gsap.timeline() の使い方（簡易版） >>>

  【効果】
  対象の要素の css プロパティを、
  特定の状態から特定の状態に遷移させる。

  ※つなげることで、状態を順番に遷移させていくことも可能。（ここでは説明しません）

  【使い方】

    ① set（プロパティの初期値を設定）

      例）opacity の初期値を 1 にする。

          tl.set(wrapper, {
            autoAlpha: 1,
          },'<')

          ※ set 使用は任意です。
            set を使用しない場合は、css で設定した値が初期値になります。

    ② to（プロパティを初期値から設定値へ変化させる）

      例）1 秒かけて opacity を 0 から 1 にする。

          tl.set(wrapper, {
            autoAlpha: 0,
          },'<')

          tl.to( 対象の要素, {
            autoAlpha: 1,
            duration: 1, // アニメーションにかける秒数
          },'<')

    ③ from（プロパティを設定値から初期値へ変化させる）

      例）1 秒かけて opacity を 0 から 1 にする。

          tl.set(wrapper, {
            autoAlpha: 1,
          },'<')

          tl.from( 対象の要素, {
            autoAlpha: 0,
            duration: 1, // アニメーションにかける秒数
          },'<')

  【よく使うプロパティ】

    tl.to( 対象の要素, {
      autoAlpha: 1, // opacity
      x: 0, // translateX
      y: 0, // translateY
      scale: 0,
      rotation: 0,
      skew: 0,
      transformOrigin: "center center"

      duration: 1, // アニメーションにかける秒数
      delay: 0,
      ease: power1.out // あらかじめ決められた設定値があるので、こだわりたい方は調べてみてください
    },'<')

    ※他にも css プロパティはほとんどそのまま設定できます。
      margin, padding, width, height, 等々。
      ハイフン区切りのものは、ローワーキャメルケースに書き換えてください。

      例）font-size → fontSize

  */

  /***********************************************************************
   * ページ読み込み時のアニメーション
   ***********************************************************************/
  gsap.set(wrapper, { autoAlpha: 1 });
  tl.to(mask, {
    autoAlpha: 0,
    duration: enterTime,
  }).to(
    wrapper,
    {
      autoAlpha: 1,
      duration: enterTime,
    },
    '<', // 直前のtoと同時にアニメーションスタート
  );

  // トップ/下層共通で、MVの立ち上がり演出を追加
  if (
    mvImgPrimary &&
    mvCirclePrimary &&
    mvCircleSecondary &&
    mvTitle
  ) {
    // トップと下層を同じ文字単位アニメーションに揃える
    if (!mvTitle.dataset.splitReady) {
      const wrapTextNodes = (node) => {
        const fragment = document.createDocumentFragment();

        node.childNodes.forEach((child) => {
          if (child.nodeType === Node.TEXT_NODE) {
            [...child.textContent].forEach((char) => {
              const span = document.createElement('span');
              span.textContent = char;
              span.style.display = 'inline-block';
              fragment.appendChild(span);
            });
            return;
          }

          if (child.nodeType === Node.ELEMENT_NODE) {
            // brなどの要素はそのまま残す
            fragment.appendChild(child.cloneNode(false));
          }
        });

        return fragment;
      };

      const wrappedContent = wrapTextNodes(mvTitle);
      mvTitle.innerHTML = '';
      mvTitle.appendChild(wrappedContent);
      mvTitle.dataset.splitReady = 'true';
    }

    const titleChars = mvTitle.querySelectorAll('span');

    gsap.set(mvImgPrimary, {
      autoAlpha: 0,
      y: -36,
      scale: 0.86,
      transformOrigin: 'center center',
    });
    if (mvImgSecondary) {
      gsap.set(mvImgSecondary, {
        autoAlpha: 0,
        y: -30,
        scale: 0.9,
        transformOrigin: 'center center',
      });
    }
    gsap.set([mvCirclePrimary, mvCircleSecondary], {
      autoAlpha: 0,
      scale: 0.92,
      transformOrigin: 'center center',
    });
    if (header) {
      gsap.set(header, { autoAlpha: 0, y: -70 });
    }
    if (menuTrigger) {
      gsap.set(menuTrigger, { autoAlpha: 0, y: -70 });
    }
    gsap.set(titleChars, { autoAlpha: 0, y: 20 });
    if (mvSubTitle) {
      gsap.set(mvSubTitle, { autoAlpha: 0, y: 24 });
    }

    tl.to(
      mvImgPrimary,
      {
        autoAlpha: 1,
        scale: 1,
        y: 0,
        duration: 0.58,
        ease: 'back.out(2)',
      },
      mvStartOffset,
    );

    if (mvImgSecondary) {
      tl.to(
        mvImgSecondary,
        {
          autoAlpha: 1,
          scale: 1,
          y: 0,
          duration: 0.42,
          ease: 'back.out(2)',
        },
        '-=0.22',
      );
    }

    tl.to(
        [mvCirclePrimary, mvCircleSecondary],
        {
          autoAlpha: 1,
          scale: 1,
          duration: 0.4,
          ease: 'power2.out',
          stagger: 0.08,
        },
        '<',
      );
    tl.to(
      titleChars,
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.45,
        ease: 'power2.out',
        stagger: 0.045,
      },
      mvTitleStartOffset,
    );

    if (mvSubTitle) {
      tl.to(
        mvSubTitle,
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.65,
          ease: 'back.out(2)',
        },
        mvSubTitleStartOffset,
      );
    }

    if (header) {
      tl.to(
        header,
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: 'back.out(2.4)',
          clearProps: 'transform',
        },
        '-=0.06',
      );
    }

    if (menuTrigger) {
      tl.to(
        menuTrigger,
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: 'back.out(2.4)',
          clearProps: 'transform',
        },
        '<',
      );
    }

    tl.call(() => {
      floatingTweens.push(
        gsap.to(mvImgPrimary, {
          y: '-=34',
          x: '+=10',
          duration: 4.2,
          repeat: -1,
          repeatDelay: 0.2,
          yoyo: true,
          ease: 'sine.inOut',
        }),
      );
      if (mvImgSecondary) {
        floatingTweens.push(
          gsap.to(mvImgSecondary, {
            y: '-=26',
            x: '-=12',
            duration: 5.1,
            repeat: -1,
            repeatDelay: 0.35,
            yoyo: true,
            delay: 0.55,
            ease: 'sine.inOut',
          }),
        );
      }
      floatingTweens.push(
        gsap.to(mvCirclePrimary, {
          y: '+=16',
          x: '-=8',
          scale: 0.96,
          duration: 6.2,
          repeat: -1,
          repeatDelay: 0.15,
          yoyo: true,
          ease: 'sine.inOut',
        }),
      );
      floatingTweens.push(
        gsap.to(mvCircleSecondary, {
          y: '-=12',
          x: '+=6',
          scale: 1.04,
          duration: 4.8,
          repeat: -1,
          repeatDelay: 0.4,
          yoyo: true,
          delay: 0.9,
          ease: 'sine.inOut',
        }),
      );
    });
  }

  /***********************************************************************
   * ページ離脱時のアニメーション
   ***********************************************************************/
  const loadingAnimation = (url) => {
    floatingTweens.forEach((tween) => tween.kill());

    tl.to(mask, {
      autoAlpha: 1,
      duration: leaveTime,
    }).to(
      wrapper,
      {
        autoAlpha: 0,
        duration: leaveTime,
      },
      '<',
    );

    // ページ遷移処理
    setTimeout(() => {
      window.location = url;
    }, leaveTime * 1000);
  };

  /***********************************************************************
   * リンク click 時の処理
   ***********************************************************************/
  // setTimeoutのdelayはbaseのwrapper::afterのtransitionと合わせる
  linkEls.forEach((linkEl) => {
    linkEl.addEventListener(
      'click',
      (e) => {
        // command or control+クリックのときは処理しない
        if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) return;

        e.preventDefault(); // cancel navigate
        e.stopPropagation(); // menuなどに伝搬されて挙動が変わる場合があるので防止
        const url = linkEl.getAttribute('href');
        if (url === null) return;
        if (url !== '' && url.indexOf(currentHostName)) {
          loadingAnimation(url);
        }
      },
      false,
    );
  });

  // SafariでブラウザバックするとJSなどが解除されていない問題【bfcache】の対策
  // 強制リロード
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // bfcache発動時の処理
      window.location.reload();
    }
  });
}
